import { Component } from '@angular/core';

@Component({
    selector: 'app-drag-drop',
    templateUrl: './drag-drop.component.html',
    styleUrls: ['./drag-drop.component.css']
})
export class DragDropComponent {
    file: any = '';

    constructor() {
        void (0);
    }

    onDone(): void {
        void (0);
    }

    fileChangeEvent(inputFile: any): void {
        if (this.checkBytes(inputFile[0].size)) {
            this.file = inputFile[0];
        } else {
            alert('doesnt work')
        }
    }

    onFileDropped(dropFile: any): void {
        if (this.checkBytes(dropFile[0].size)) {
            this.file = dropFile[0];
        } else {
            alert('doesnt work')
        }
    }

    private checkBytes(bytes): boolean {
        const result = bytes / (1024 * 1024);
        return result > 10 ? false : true;
    }

}